// Format price with space between thousands
const formatPrice = price => {
    if (typeof price === 'string') {
        price = price.replace(',', '');
        price = parseFloat(price);
    }

    if (isNaN(price)) {
        // eslint-disable-next-line no-console
        console.error('Invalid price:', price);
        return price;
    }

    const removeDecimals = parseInt(price);
    return removeDecimals.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};

export default formatPrice;
